import {
  InsuranceImport,
  InsuranceImportJobStatus,
  InsuranceImportJobType,
  SharedFileRequestJobStatus
} from "@wingspanhq/wingspan-api-sdk";

import { ValidationItemProps } from "../components/AIValidationWidget/ValidationItem";

const JOB_STATUSES: Record<
  InsuranceImportJobStatus,
  SharedFileRequestJobStatus
> = {
  [InsuranceImportJobStatus.CREATED]: SharedFileRequestJobStatus.CREATED,
  [InsuranceImportJobStatus.PENDING]: SharedFileRequestJobStatus.PENDING,
  [InsuranceImportJobStatus.PROCESSING]: SharedFileRequestJobStatus.PROCESSING,
  [InsuranceImportJobStatus.COMPLETE]: SharedFileRequestJobStatus.COMPLETE,
  [InsuranceImportJobStatus.ERROR]: SharedFileRequestJobStatus.ERROR,
  [InsuranceImportJobStatus.FAILED]: SharedFileRequestJobStatus.FAILED
};

/**
 * The per-check results of a certificate-of-insurance import, as the shared
 * validation widget reads them. Only the `Validation` jobs are checks a payee
 * can act on — the `Extraction` job is the machinery that produced the policies
 * under review, and it is reported through the document's own status instead.
 *
 * `jobs` is empty until the backend starts processing, which renders as no
 * items.
 */
export const selectorInsuranceImportValidationItems = (
  insuranceImport: InsuranceImport
): ValidationItemProps[] =>
  (insuranceImport.jobs ?? [])
    .filter(job => job.type === InsuranceImportJobType.VALIDATION)
    .map(job => ({
      title: job.title,
      description: job.description,
      type: job.type,
      status: job.status
        ? JOB_STATUSES[job.status]
        : SharedFileRequestJobStatus.CREATED,
      statusReason: job.statusReason ?? undefined
    }));
